import * as Models from 'models';
import { isReusableLayoutDocument } from 'utils/entityType/isReusableLayoutDocument';

export function isReusableLayoutEdited(document: Models.CombinedDocument): boolean {
  return isReusableLayoutDocument(document) && document.isEdited;
}
